import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const AnimatedWrapper = styled.div`
  margin: 2rem auto 0 auto;
`

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 1.2rem;
`

export const ActionWrapper = styled.span`
  margin-left: 1rem;
`



// WEBPACK FOOTER //
// ./src/Components/SweetAlert/styles.js